// (function() {

// 	"use strict"

// 	/**
// 	*
// 	*	Content Controller
// 	*
// 	*	provides a short unified way to link content to a view
// 	*/

// 	angular.module( "ATMGurus" )

// 	.controller( "ContentController", [
// 		"ContentService",
// 		"$stateParams",
// 		"loadContent",
// 		function( Content, $stateParams, loadContent ) {

// 			var _this = this;

// 			this.Content  = loadContent

// 		}
// 	] )
// })()


// WEBPACK FOOTER //
// ./src/app/controllers/ContentController.js